import { Box, Container, Typography, Grid, Divider } from "@mui/material";
import { ModuleCard } from "./ModuleCard";

/* Constants */
const HEADING_SPACING = 8;
const SUBHEADING_SPACING = 2;
const DIVIDER_SPACING_TOP = 3;
const DIVIDER_SPACING_BOTTOM = 6;
const SECTION_SPACING = 6;

export const ModulesDashboard = ({ modules, accountInfo }) => {
  // Check if AI toolkit has multiple tools -> This determines if ALL cards need to reserve space for alignment
  const aiToolkitModule = modules.find((m) => m.id === "ai-toolkit");
  const aiToolkitSubModules =
    aiToolkitModule?.hasSubModules &&
    typeof aiToolkitModule.getSubModules === "function"
      ? aiToolkitModule.getSubModules(accountInfo)
      : [];

  // If AI Toolkit has multiple tools, all cards need to reserve badge space
  const shouldReserveSpaceForBadge = aiToolkitSubModules.length > 1;

  return (
    <Box
      sx={{
        minHeight: "100vh",
      }}
    >
      {/* Keyframes for float animation */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>
      <Container maxWidth="lg">
        <Box sx={{ mb: SECTION_SPACING }}>
          {/* Header */}
          <Typography variant="h1" sx={{ mb: HEADING_SPACING, color: "primary.white" }}>
            Welcome to{" "}
            <Box component="span" sx={{ color: "primary.brandMain" }}>
              Anvil Insight
            </Box>
          </Typography>

          {/* Sub-heading */}
          <Box sx={{ mt: SUBHEADING_SPACING }}>
            <Typography variant="subtitle1" sx={{ py: 0.3, color: "primary.brandMain" }}>
              Your Modules
            </Typography>
            <Typography
              variant="subtitle3"
              sx={{ fontWeight: 300, color: "primary.white" }}
            >
              Select a module to access analytics and insights
            </Typography>
          </Box>

          <Divider
            sx={{
              mt: DIVIDER_SPACING_TOP,
              mb: DIVIDER_SPACING_BOTTOM,
              borderColor: "primary.brandMain",
            }}
          />

          {/* Modules Grid*/}
          <Grid container spacing={2}>
            {modules.map((module) => (
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }} key={module.id}>
                <ModuleCard
                  module={module}
                  accountInfo={accountInfo}
                  shouldReserveSpaceForBadge={shouldReserveSpaceForBadge}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};
